import React from 'react';
import { Route, Routes } from 'react-router-dom';

import ProductEndOfLife from '../../shared/pages/ProductEndOfLife/ProductEndOfLife';

const StudentAuthenticatedApp = () => {
  return (
    <Routes>
      <Route path="*" element={<ProductEndOfLife title="Student Portal" />} />
    </Routes>
  );
};

export default StudentAuthenticatedApp;
